function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module autosave/autosave
 */
import { Plugin, PendingActions } from 'ckeditor5/src/core';
import { DomEmitterMixin, ObservableMixin, mix } from 'ckeditor5/src/utils';
import { debounce } from 'lodash-es';
/* globals window */

/**
 * The {@link module:autosave/autosave~Autosave} plugin allows you to automatically save the data (e.g. send it to the server)
 * when needed (when the user changed the content).
 *
 * It listens to the {@link module:engine/model/document~Document#event:change:data `editor.model.document#change:data`}
 * and `window#beforeunload` events and calls the
 * {@link module:autosave/autosave~AutosaveAdapter#save `config.autosave.save()`} function.
 *
 *		ClassicEditor
 *			.create( document.querySelector( '#editor' ), {
 *				plugins: [ ArticlePluginSet, Autosave ],
 *				toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo' ],
 *				image: {
 *					toolbar: [ 'imageStyle:block', 'imageStyle:side', '|', 'toggleImageCaption', 'imageTextAlternative' ],
 *				},
 *				autosave: {
 *					save( editor ) {
 *						// The saveData() function must return a promise
 *						// which should be resolved when the data is successfully saved.
 *						return saveData( editor.getData() );
 *					}
 *				}
 *			} );
 *
 * Read more about this feature in the {@glink builds/guides/integration/saving-data#autosave-feature Autosave feature}
 * section of the {@glink builds/guides/integration/saving-data Saving and getting data}.
 *
 * @extends module:core/plugin~Plugin
 */

var Autosave = /*#__PURE__*/function (_Plugin) {
  _inherits(Autosave, _Plugin);

  var _super = _createSuper(Autosave);

  /**
   * @inheritDoc
   */
  function Autosave(editor) {
    var _this;

    _classCallCheck(this, Autosave);

    _this = _super.call(this, editor);
    var config = editor.config.get('autosave') || {}; // A minimum amount of time that needs to pass after the last action.
    // After that time the provided save callbacks are being called.

    var waitingTime = config.waitingTime || 1000;
    /**
     * The adapter is an object with a `save()` method. That method will be called whenever
     * the data changes. It might be called some time after the change,
     * since the event is throttled for performance reasons.
     *
     * @member {module:autosave/autosave~AutosaveAdapter} #adapter
     */

    /**
     * The state of this plugin.
     *
     * The plugin can be in the following states:
     *
     * * synchronized &ndash; When all changes are saved.
     * * waiting &ndash; When the plugin is waiting for other changes before calling `adapter#save()` and `config.autosave.save()`.
     * * saving &ndash; When the provided save method is called and the plugin waits for the response.
     * * error &ndash When the provided save method will throw an error. This state immediately changes to the `saving` state and
     * the save method will be called again in the short period of time.
     *
     * @member {'synchronized'|'waiting'|'saving'} #state
     */

    _this.set('state', 'synchronized');
    /**
     * Debounced save method. The `save()` method is called the specified `waitingTime` after `debouncedSave()` is called,
     * unless a new action happens in the meantime.
     *
     * @private
     * @type {Function}
     */


    _this._debouncedSave = debounce(_this._save.bind(_assertThisInitialized(_this)), waitingTime);
    /**
     * The last document version.
     *
     * @private
     * @type {Number}
     */

    _this._lastDocumentVersion = editor.model.document.version;
    /**
     * DOM emitter.
     *
     * @private
     * @type {DomEmitterMixin}
     */

    _this._domEmitter = Object.create(DomEmitterMixin);
    /**
     * The configuration of this plugins.
     *
     * @private
     * @type {Object}
     */

    _this._config = config;
    /**
     * An action that will be added to pending action manager for actions happening in that plugin.
     *
     * @private
     * @member {Object} #_action
     */

    /**
     * Editor's pending actions manager.
     *
     * @private
     * @member {module:core/pendingactions~PendingActions} #_pendingActions
     */

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(Autosave, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor;
      var doc = editor.model.document;
      var t = editor.t;
      this._pendingActions = editor.plugins.get(PendingActions);
      this.listenTo(doc, 'change:data', function () {
        if (!_this2._saveCallbacks.length) {
          return;
        }

        if (_this2.state == 'synchronized') {
          _this2._action = _this2._pendingActions.add(t('Saving changes'));
          _this2.state = 'waiting';

          _this2._debouncedSave();
        } else if (_this2.state == 'waiting') {
          _this2._debouncedSave();
        } // If the plugin is in `saving` state, it will change its state later basing on the `document.version`.
        // If the `document.version` will be higher than stored `#_lastDocumentVersion`, then it means, that some `change:data`
        // event has fired in the meantime.

      }); // Flush on the editor's destroy listener with the highest priority to ensure that
      // `editor.getData()` will be called before plugins are destroyed.

      this.listenTo(editor, 'destroy', function () {
        return _this2._flush();
      }, {
        priority: 'highest'
      }); // It's not possible to easy test it because karma uses `beforeunload` event
      // to warn before full page reload and this event cannot be dispatched manually.

      /* istanbul ignore next */

      this._domEmitter.listenTo(window, 'beforeunload', function (evtInfo, domEvt) {
        if (_this2._pendingActions.hasAny) {
          domEvt.returnValue = _this2._pendingActions.first.message;
        }
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      // There's no need for canceling or flushing the throttled save, as
      // it's done on the editor's destroy event with the highest priority.
      this._domEmitter.stopListening();

      _get(_getPrototypeOf(Autosave.prototype), "destroy", this).call(this);
    }
    /**
     * Invokes the remaining `_save()` method call.
     *
     * @protected
     */

  }, {
    key: "_flush",
    value: function _flush() {
      this._debouncedSave.flush();
    }
    /**
     * If the adapter is set and a new document version exists,
     * the `_save()` method creates a pending action and calls the `adapter.save()` method.
     * It waits for the result and then removes the created pending action.
     *
     * @private
     */

  }, {
    key: "_save",
    value: function _save() {
      var _this3 = this;

      var version = this.editor.model.document.version; // Change may not produce an operation, so the document's version
      // can be the same after that change.

      if (version < this._lastDocumentVersion || this.editor.state === 'initializing') {
        this._debouncedSave.cancel();

        return;
      }

      this._lastDocumentVersion = version;
      this.state = 'saving'; // Wait one promise cycle to be sure that save callbacks are not called
      // inside a conversion or when the editor's state changes.

      Promise.resolve().then(function () {
        return Promise.all(_this3._saveCallbacks.map(function (cb) {
          return cb(_this3.editor);
        }));
      }) // In case of an error re-try the save later and throw the original error.
      // Being in the `saving` state ensures that the debounced save action
      // won't be delayed further by the `change:data` event listener.
      .catch(function (err) {
        _this3.state = 'error'; // Change immediately to the `saving` state so the `change:state` event will be fired.

        _this3.state = 'saving';

        _this3._debouncedSave();

        throw err;
      }).then(function () {
        if (_this3.editor.model.document.version > _this3._lastDocumentVersion) {
          _this3.state = 'waiting';

          _this3._debouncedSave();
        } else {
          _this3.state = 'synchronized';

          _this3._pendingActions.remove(_this3._action);

          _this3._action = null;
        }
      });
    }
    /**
     * Saves callbacks.
     *
     * @private
     * @type {Array.<Function>}
     */

  }, {
    key: "_saveCallbacks",
    get: function get() {
      var saveCallbacks = [];

      if (this.adapter && this.adapter.save) {
        saveCallbacks.push(this.adapter.save);
      }

      if (this._config.save) {
        saveCallbacks.push(this._config.save);
      }

      return saveCallbacks;
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'Autosave';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [PendingActions];
    }
  }]);

  return Autosave;
}(Plugin);

export { Autosave as default };
mix(Autosave, ObservableMixin);
/**
 * An interface that requires the `save()` method.
 *
 * Used by {@link module:autosave/autosave~Autosave#adapter}.
 *
 * @interface module:autosave/autosave~AutosaveAdapter
 */

/**
 * The method that will be called when the data changes. It should return a promise (e.g. in case of saving content to the database),
 * so the autosave plugin will wait for that action before removing it from pending actions.
 *
 * @method #save
 * @param {module:core/editor/editor~Editor} editor The editor instance.
 * @returns {Promise.<*>}
 */

/**
 * The configuration of the {@link module:autosave/autosave~Autosave autosave feature}.
 *
 * Read more in {@link module:autosave/autosave~AutosaveConfig}.
 *
 * @member {module:autosave/autosave~AutosaveConfig} module:core/editor/editorconfig~EditorConfig#autosave
 */

/**
 * The configuration of the {@link module:autosave/autosave~Autosave autosave feature}.
 *
 *		ClassicEditor
 *			.create( editorElement, {
 *				autosave: {
 *					save( editor ) {
 *						// The saveData() function must return a promise
 *						// which should be resolved when the data is successfully saved.
 *						return saveData( editor.getData() );
 *					}
 *				}
 *			} );
 *			.then( ... )
 *			.catch( ... );
 *
 * See {@link module:core/editor/editorconfig~EditorConfig all editor configuration options}.
 *
 * See also the demo of the {@glink builds/guides/integration/saving-data#autosave-feature autosave feature}.
 *
 * @interface AutosaveConfig
 */

/**
 * The callback to be executed when the data needs to be saved.
 *
 * This function must return a promise which should be resolved when the data is successfully saved.
 *
 *		ClassicEditor
 *			.create( editorElement, {
 *				autosave: {
 *					save( editor ) {
 *						return saveData( editor.getData() );
 *					}
 *				}
 *			} );
 *			.then( ... )
 *			.catch( ... );
 *
 * @method module:autosave/autosave~AutosaveConfig#save
 * @param {module:core/editor/editor~Editor} editor The editor instance.
 * @returns {Promise.<*>}
 */

/**
 * The minimum amount of time that needs to pass after the last action to call the provided callback.
 * By default it is 1000 ms.
 *
 *		ClassicEditor
 *			.create( editorElement, {
 *				autosave: {
 *					save( editor ) {
 *						return saveData( editor.getData() );
 *					},
 *					waitingTime: 2000
 *				}
 *			} );
 *			.then( ... )
 *			.catch( ... );
 *
 * @member {Number} module:autosave/autosave~AutosaveConfig#waitingTime
 */